///Users/admin/email-preview-tool/email-preview/src/store/dataReducers/index.ts
import { RunContextApp }        from "framework/RCApp"
import { combineReducers }      from "redux"
import { sessionReducer } from "./SessionReducer"
import { herReducer } from "./HERReducer"


export const allReducers = (rc : RunContextApp) => combineReducers({
  session : sessionReducer(rc),
  her : herReducer(rc),

})